import React, { useEffect, useMemo, useState } from "react";
import { withRouter } from "react-router-dom";
import HeaderMandG from "../../Components/MandG/Header";
import { moduleid } from "../../Utils/static-strings";
import ContinueButton from "../../Components/ContinueButton";
const textColor = "var(--text-color-default)";

const moduleOrder = [
  moduleid.risk(),
  moduleid.loss(),
  moduleid.future(),
  moduleid.experience(),
];

const Index = (props) => {
  const completedModules = useMemo(() => {
    const modulesFromCalc = Array.isArray(props.riskCalculation?.modules)
      ? props.riskCalculation.modules
      : [];
    const done = new Set(
      modulesFromCalc
        .filter((mod) => mod.completedat)
        .map((mod) => mod.moduleid)
    );
    if (props.finishAnimate) {
      done.add(props.finishAnimate);
    }
    return Array.from(done);
  }, [props.finishAnimate, props.riskCalculation]);

  const hasProgress = useMemo(
    () => completedModules.length > 0,
    [completedModules.length]
  );

  // Skip the welcome screen if the user has already started modules
  const [showIntro, setShowIntro] = useState(() => !hasProgress);

  const availableModules = useMemo(() => {
    const available = props.modules?.modules || [];
    return moduleOrder.filter((id) =>
      available.some((module) => module.moduleid === id)
    );
  }, [props.modules]);

  useEffect(() => {
    if (hasProgress) {
      setShowIntro(false);
    }
  }, [hasProgress]);

  const nextModule = availableModules.find(
    (id) => !completedModules.includes(id)
  );

  const showThankYou = !showIntro && props.testCompleted;

  useEffect(() => {
    if (!showIntro) {
      if (props.testCompleted) {
        props.history.push("/thankyou");
        return;
      }
      if (nextModule) {
        props.history.push(`/activityType/${nextModule}`);
      }
    }
  }, [nextModule, props.history, props.testCompleted, showIntro]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        width: "100vw",
        backgroundColor: "var(--mandg-alt-background)",
      }}
    >
      <HeaderMandG currentRoute={"Understanding"} />
      <div
        style={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          gap: 24,
          padding: 24,
        }}
      >
        {showIntro ? (
          <>
            <h1
              style={{
                // fontFamily: "Infra",
                fontSize: 32,
                letterSpacing: 1,
                margin: 0,
                color: textColor,
              }}
            >
              Risk Tolerance
            </h1>
            <p
              style={{
                maxWidth: 520,
                textAlign: "center",
                margin: 0,
                fontFamily: "Infra",
                fontSize: 18,
                lineHeight: "28px",
                color: textColor,
              }}
            >
              Understanding your risk tolerance is the cornerstone of successful
              investment planning.
            </p>
            <p
              style={{
                maxWidth: 520,
                textAlign: "center",
                margin: 0,
                fontFamily: "Infra",
                fontSize: 18,
                lineHeight: "28px",
                color: textColor,
              }}
            >
              The next few screens will assess your investment risk tolerance.
            </p>
            <ContinueButton onClick={() => setShowIntro(false)} />
          </>
        ) : null}
        {showThankYou ? (
          <p
            style={{
              fontFamily: "Infra",
              fontSize: 19,
              color: textColor,
              margin: 0,
            }}
          >
            Thanks for completing the profiler. Please use the booking link in
            the email to schedule a time with an adviser.
          </p>
        ) : null}
      </div>
    </div>
  );
};

export default withRouter(Index);
